import React from 'react';
import styled from 'styled-components';

export const AmenityWrapper = styled.div({
    height: '16px',
});
